import { React, useEffect, useState } from "react";
import PlantillaScreen from "../../../helpers/PlantillaScreen";
import { useHistory, useLocation } from "react-router-dom";
import FormatListNumberedIcon from "@mui/icons-material/FormatListNumbered";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { LoaderScreen } from "../../../components/LoaderScreen";
import Swal from "sweetalert2";
import request from "../../../../Helpers/API";
import { FormatMoney } from "../../../../Helpers/FormatNumber";
import CloudDownloadIcon from '@mui/icons-material/CloudDownload';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import { CargarConvenioModal } from "../Modal/CargarConvenioModal";
import { DescargarConvenioModal } from "../Modal/DescargarConvenioModal";
import PersonAddIcon from '@mui/icons-material/PersonAdd';
import FiltroConveniosRealizados from "../Components/FiltroConveniosRealizados";
import { useBox } from "../../ReporteCobranza/Helper/useBox";
import { GetKey } from "../../ReporteCobranza/Actions/GetContainer";

export const ListadoGestionesRealizadasScreen = () => {
    const history = useHistory();
    const { state } = useLocation();
    const [gestiones, setGestiones] = useState([])
    const [openModal, setOpenModal] = useState(false)
    const [modalDescarga, setModalDescarga] = useState(false);

    const today = new Date();
    const currentYear = today.getFullYear();
    const currentMonth = today.getMonth() + 1;

    const fechaInicio = new Date(`${currentYear}-${currentMonth}-01`).toISOString().split('T')[0]
    const fechaFin = today.toISOString().split('T')[0]

    const initialStateboxfiltros = () => {
        return {
            fechaInicio: fechaInicio,
            fechaFin: fechaFin,
            responsable: "0",
            objecion:"999",
            rango: "0",
            pv: {
                adr: [],
                sucursal: [],
                vendedor: [],
            },
        };
    };
    const [boxstate, setBoxState] = useBox(initialStateboxfiltros);

    const [folio, setFolio] = useState('')
    const [titulo, setTitulo] = useState("BITACORA DE GESTION DE COBRANZA")

    const [loader, setLoader] = useState({
        mostrar: false,
        alerta: false,
        error: false,
        mensaje: "",
    });

    const handleOpenModal = (folio) => {
        setOpenModal(true);
        setFolio(folio)
    }

    const handleCloseModal = () => {
        setOpenModal(false);
    };

    const abrirModalDescarga = (folio) => {
        setModalDescarga(true);
        setFolio(folio)
    };

    const cerrarModalDescarga = () => {
        setModalDescarga(false);
    };


    useEffect(() => {
        setLoader({ ...loader, mostrar: true });

        onExecute(fechaInicio, fechaFin, 0);
        setLoader({ ...loader, mostrar: false });
    }, []);
    const onExecute = (fechaInicio, fechaFin, responsable) => {
        var sucursales = GetKey(boxstate.pv.sucursal, ["idsucursal"]);
        var adr = GetKey(boxstate.pv.adr, ["idadr"]);
        if (sucursales === undefined || sucursales === null || sucursales === "") {
            sucursales = "0";
        }
        if (adr === undefined || adr === null || adr === "") {
            adr = "0";
        }
        // Convertimos el string a partes numéricas para evitar problemas de timezone
        const [anioI, mesI, diaI] = fechaInicio.split("-").map(Number);
        const [anioF, mesF, diaF] = fechaFin.split("-").map(Number);

        // Creamos las fechas usando Date(year, monthIndex, day)
        const fechaI = new Date(anioI, mesI - 1, diaI);
        const fechaF = new Date(anioF, mesF - 1, diaF);

        const meses = [
            "ENERO", "FEBRERO", "MARZO", "ABRIL", "MAYO", "JUNIO",
            "JULIO", "AGOSTO", "SEPTIEMBRE", "OCTUBRE", "NOVIEMBRE", "DICIEMBRE"
        ];

        const mesInicio = meses[fechaI.getMonth()];
        const mesFin = meses[fechaF.getMonth()];
        const anioInicio = fechaI.getFullYear();
        const anioFin = fechaF.getFullYear();

        let rangoFechas = "";
        if (anioInicio === anioFin) {
            rangoFechas = `${mesInicio} - ${mesFin} - ${anioFin}`;
        } else {
            rangoFechas = `${mesInicio} ${anioInicio} - ${mesFin} ${anioFin}`;
        }

        const tituloP = `BITACORA DE GESTION DE COBRANZA - ${rangoFechas}`;

        setTitulo(tituloP);

        // console.log(adr, sucursales)
        return new Promise((resolve, reject) => {
            setLoader({ ...loader, mostrar: true });
            request
                .get(
                    `ListadoGestionesRealizadasComentario/ListadoParametros?fechainicio=${fechaInicio}&fechafin=${fechaFin}&responsable=${responsable}&objecion=${boxstate.objecion}&sucursal=${sucursales}&adr=${adr}`
                )
                .then((result) => {
                    setLoader({ ...loader, mostrar: false });
                    setGestiones(result)
                    return;
                })
                .catch((error) => {
                    setLoader({ ...loader, mostrar: false });
                    reject(error);
                    return;
                });
        });

    };
    console.log(boxstate)

    const onGeneraExcel = (fechaInicio, fechaFin, responsable) => {
        var sucursales = GetKey(boxstate.pv.sucursal, ["idsucursal"]);
        var adr = GetKey(boxstate.pv.adr, ["idadr"]);
        if (sucursales === undefined || sucursales === null || sucursales === "") {
            sucursales = "0";
        }
        if (adr === undefined || adr === null || adr === "") {
            adr = "0";
        }

        // Convertimos el string a partes numéricas para evitar problemas de timezone
        const [anioI, mesI, diaI] = fechaInicio.split("-").map(Number);
        const [anioF, mesF, diaF] = fechaFin.split("-").map(Number);

        // Creamos las fechas usando Date(year, monthIndex, day)
        const fechaI = new Date(anioI, mesI - 1, diaI);
        const fechaF = new Date(anioF, mesF - 1, diaF);

        const meses = [
            "ENERO", "FEBRERO", "MARZO", "ABRIL", "MAYO", "JUNIO",
            "JULIO", "AGOSTO", "SEPTIEMBRE", "OCTUBRE", "NOVIEMBRE", "DICIEMBRE"
        ];

        const mesInicio = meses[fechaI.getMonth()];
        const mesFin = meses[fechaF.getMonth()];
        const anioInicio = fechaI.getFullYear();
        const anioFin = fechaF.getFullYear();

        let rangoFechas = "";
        if (anioInicio === anioFin) {
            rangoFechas = `${mesInicio} - ${mesFin} - ${anioFin}`;
        } else {
            rangoFechas = `${mesInicio} ${anioInicio} - ${mesFin} ${anioFin}`;
        }

        const tituloP = `BITACORA DE GESTION DE COBRANZA - ${rangoFechas}`;

        setLoader({ ...loader, mostrar: true });
        request
            .get(`ListadoGestionesRealizadasComentario/ImprimirExcel?fechainicio=${fechaInicio}&fechafin=${fechaFin}&responsable=${responsable}&objecion=${boxstate.objecion}&sucursal=${sucursales}&adr=${adr}&titulo=${tituloP}`)
            .then(({ documento, filename }) => {
                const linkSource = `data:application/vnd.ms-excel;base64,${documento}`;
                const downloadLink = document.createElement("a");
                const fileName = `${filename}.xlsx`;
                downloadLink.href = linkSource;
                downloadLink.download = fileName;
                downloadLink.click();
                setLoader({ ...loader, mostrar: false });
            })
            .catch((error) => {
                setLoader({ ...loader, mostrar: false });
                Swal.fire("CREDITO Y COBRANZA", JSON.stringify(error), "error");
            });
    };

    const onGeneraPDF = (fechaInicio, fechaFin, responsable) => {
        var sucursales = GetKey(boxstate.pv.sucursal, ["idsucursal"]);
        var adr = GetKey(boxstate.pv.adr, ["idadr"]);
        if (sucursales === undefined || sucursales === null || sucursales === "") {
            sucursales = "0";
        }
        if (adr === undefined || adr === null || adr === "") {
            adr = "0";
        }

        // Convertimos el string a partes numéricas para evitar problemas de timezone
        const [anioI, mesI, diaI] = fechaInicio.split("-").map(Number);
        const [anioF, mesF, diaF] = fechaFin.split("-").map(Number);

        // Creamos las fechas usando Date(year, monthIndex, day)
        const fechaI = new Date(anioI, mesI - 1, diaI);
        const fechaF = new Date(anioF, mesF - 1, diaF);

        const meses = [
            "ENERO", "FEBRERO", "MARZO", "ABRIL", "MAYO", "JUNIO",
            "JULIO", "AGOSTO", "SEPTIEMBRE", "OCTUBRE", "NOVIEMBRE", "DICIEMBRE"
        ];

        const mesInicio = meses[fechaI.getMonth()];
        const mesFin = meses[fechaF.getMonth()];
        const anioInicio = fechaI.getFullYear();
        const anioFin = fechaF.getFullYear();

        let rangoFechas = "";
        if (anioInicio === anioFin) {
            rangoFechas = `${mesInicio} - ${mesFin} - ${anioFin}`;
        } else {
            rangoFechas = `${mesInicio} ${anioInicio} - ${mesFin} ${anioFin}`;
        }

        const tituloP = `BITACORA DE GESTION DE COBRANZA - ${rangoFechas}`;
        setLoader({ ...loader, mostrar: true });
        request
            .get(`ListadoGestionesRealizadasComentario/ImprimirPDF?fechainicio=${fechaInicio}&fechafin=${fechaFin}&responsable=${responsable}&objecion=${boxstate.objecion}&sucursal=${sucursales}&adr=${adr}&titulo=${tituloP}`)
            .then((result) => {
                setLoader({ ...loader, mostrar: false });
                const linkSource = `data:application/pdf;base64, ${result.documento}`;
                const downloadLink = document.createElement("a");
                const fileName = `${result.nombredocumento}.${result.extension}`;
                downloadLink.href = linkSource;
                downloadLink.download = fileName;
                downloadLink.click();
            })
            .catch((error) => {
                setLoader({ ...loader, mostrar: false });
                Swal.fire("Clientes", JSON.stringify(error), "error");
            });
    };


    return (
        <PlantillaScreen
            titulo={titulo}
            className={"convenio-pago-main-screen"}
            className_main={1}
        >
            <div className="bitacora-gestion-actions">
                <div
                    className="bitacora-gestion-actions-regresar"
                    onClick={() => history.goBack()}
                >
                    <ArrowBackIcon /> Regresar
                </div>
                <div className="bitacora-gestion-actions-filtro">
                    <FiltroConveniosRealizados
                        onExecute={onExecute}
                        boxState={boxstate}
                        onBoxChange={setBoxState}
                        mostrarObjecion={true}
                        // mostrarRango={true}
                    />
                </div>
                <div className="buttons">
                    <button className="excel"
                        onClick={() => onGeneraExcel(boxstate.fechaInicio, boxstate.fechaFin, boxstate.responsable)}
                    >
                        <i className=" icon-file-excel" /> Excel
                    </button>
                    <button className="PDF"
                        onClick={() =>
                            onGeneraPDF(boxstate.fechaInicio, boxstate.fechaFin, boxstate.responsable)
                        }
                        style={{ backgroundColor: '#940404' }}>
                        PDF
                    </button>
                </div>
            </div>
            <div className="bitacora-gestion-cliente">
                <LoaderScreen loader={loader} />
                <div className="bitacora-gestion-cliente-header">
                    <div className="bitacora-gestion-cliente-header-title">
                        <FormatListNumberedIcon /> Listado de Gestiones Realizadas
                    </div>
                    <div className="contador-gestiones-encontrados">
                        Gestiones Encontradas: {gestiones.length}
                    </div>
                </div>
                <div className="bitacora-gestion-cliente-container scroll-4">
                    <table>
                        <thead>
                            <tr>
                                {/* <th>No. Gestión</th> */}
                                <th>
                                    Cliente
                                </th>
                                <th>
                                    <div>Responsable</div>
                                </th>
                                <th>
                                    <div>Volver a Contactar</div>
                                </th>
                                <th>
                                    <div>Fecha para Contactar</div>
                                </th>
                                <th>
                                    <div>Comentario</div>
                                </th>
                                <th>
                                    <div>Objecion</div>
                                </th>
                                <th>
                                    <div>Saldo</div>
                                </th>
                                <th>
                                    <div>Interés Pactado</div>
                                </th>
                                <th>
                                    <div>Interés Moratorio</div>
                                </th>
                                <th>
                                    <div>Total</div>
                                </th>
                                <th>
                                    <div>Fecha de Gestión</div>
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            {gestiones.map((ge) => (
                                <tr>
                                    {/* <td className="ta-center">{ge.idgestion}</td> */}
                                    <td className="ta-left">{ge.razonSocial}</td>
                                    {/* <td className="ta-left">{ge.vencimiento ? ge.vencimiento.split("T")[0].split("-").reverse().join("/") : "-"}</td> */}
                                    <td className="ta-left">{ge.responsable}</td>
                                    <td className="ta-center">{ge.volvercontactar}</td>
                                    <td className="ta-center ta-fecha">{ge.fechavolvercontactar ? ge.fechavolvercontactar.split("T")[0].split("-").reverse().join("/") : "-"}</td>
                                    <td className="ta-left ta-comentario">{ge.comentarios}</td>
                                    <td className="ta-left">{ge.objecion}</td>
                                    <td className="ta-right">{FormatMoney(ge.saldo)}</td>
                                    <td className="ta-right">{FormatMoney(ge.interespactado)}</td>
                                    <td className="ta-right">{FormatMoney(ge.moratorios)}</td>
                                    <td className="ta-right">{FormatMoney(ge.total)}</td>
                                    <td className="ta-center ta-fecha">{ge.createdate ? ge.createdate.split("T")[0].split("-").reverse().join("/") : "-"}</td>
                                    {/* <td>
                                        <div className="convenio-pago-acciones-listado">
                                            <div className="boton-descargar-convenio-pago-pdf" onClick={() => abrirModalDescarga(vc.folio)}><CloudDownloadIcon /> Descargar </div>
                                            <div className="boton-subir-evidencia-convenio-pago" onClick={() => handleOpenModal(vc.folio)}><CloudUploadIcon />Cargar</div>
                                        </div>
                                    </td> */}
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
                <CargarConvenioModal open={openModal} handleCloseModal={handleCloseModal} folio={folio} />
                <DescargarConvenioModal open={modalDescarga} onClose={cerrarModalDescarga} folio={folio} />
            </div>
        </PlantillaScreen>
    );
};
